import { keyframes } from '@emotion/react';
import { Box, styled } from '@mui/material';

const press = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(0.95); }
    100% { transform: scale(1); }
  `;

export const StyledAddItemContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    !['isClicked', 'isFullHeight', 'isFullWidth', 'variant', 'isDisabled'].includes(prop),
})<{
  isClicked?: boolean;
  isFullWidth?: boolean;
  isDisabled?: boolean;
  isFullHeight?: boolean;
  variant?: 'default' | 'shortHeight' | 'shortWidth';
}>(({ theme, isClicked, isFullWidth, isFullHeight, variant, isDisabled }) => {
  const width = variant === 'shortWidth' ? '40px' : isFullWidth ? '100%' : '320px';
  const height = variant === 'shortHeight' ? '36px' : isFullHeight ? '100%' : '180px';

  return {
    flexDirection: 'column',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: isDisabled ? 'default' : 'pointer',
    width,
    height,
    border: `1px dashed ${theme.palette.case.neutral.n400}`,
    borderRadius: '8px',
    transition: '0.4s all',
    userSelect: 'none',
    color: isDisabled ? theme.palette.case.neutral.n400 : theme.palette.case.aquamarine.a700,
    svg: {
      width: '20px',
      height: '20px',
      path: {
        fill: isDisabled ? theme.palette.case.neutral.n400 : theme.palette.case.aquamarine.a700,
        transition: '0.4s all',
      },
    },
    '&:hover': !isDisabled && {
      border: `1px dashed ${theme.palette.case.primary.p800}`,
      color: theme.palette.case.primary.p800,
      svg: {
        path: {
          fill: theme.palette.case.primary.p800,
        },
      },
    },
    ...(isClicked && {
      animation: `${press} 0.3s ease`,
    }),
  };
});
